import React, { Component } from "react";

import Aux from "../Aux/Aux";
import classes from "./Layout.css";
import Toolbar from "../../components/Navigation/Toolbar/Toolbar";

import Background from "../../assets/images/background-01.jpg";

const backgroundStyle = {
    position: "fixed",
    top: 0,
    border: "1px solid #000",
    backgroundColor: "#000000",
    backgroundImage: `url(${Background})`,
    backgroundSize: "cover",
    backgroundPosition: "center center",
    width: "100vw",
    height: "100vh",
    zIndex: "-1",
    // "-webkit-filter": "brightness(50%)",
    WebkitFilter: "brightness(40%)",
};

class Layout extends Component {
    state = {
        showSideDrawer: false,
    };

    sideDrawerClosedHandler = () => {
        this.setState({ showSideDrawer: false });
    };

    sideDrawerToggleHandler = () => {
        this.setState((prevState) => {
            return { showSideDrawer: !prevState.showSideDrawer };
        });
    };

    render() {
        return (
            <Aux>
                <div style={backgroundStyle} />
                <Toolbar
                    pageid={this.props.pageid}
                    navclick={this.props.navclick}
                    drawerToggleClicked={this.sideDrawerToggleHandler}
                />
                <main className={classes.Content}>{this.props.children}</main>
            </Aux>
        );
    }
}

export default Layout;



// WEBPACK FOOTER //
// ./src/hoc/Layout/Layout.js